<template>
    <DefaultBackground>
        <section class="m-2 md:m-10">
            <div class="container mx-auto">
                <div class="bg-white rounded-lg shadow-card">
                    <header class="px-6 py-4">
                        <router-link :to="{name: 'orders.index'}">
                            <img src="@/assets/images/ic_arrow_back.svg" alt="BuildaBox Individual Order Details Navigation Back" class="inline-block" />
                            <span class="text-primary font-semibold ml-3">Back to Projects</span>
                        </router-link>

                        <div class="flex flex-col md:flex-row justify-between mt-3">
                            <h1 class="font-semibold text-2xl lg:text-3xl">Team Event Launch</h1>
                            <div class="mt-8 md:mt-0 flex flex-col md:flex-row">
                                <button class="btn btn-primary font-semibold rounded-lg px-12 w-full md:w-40 mr-0 md:mr-5 mb-5 md:mb-0" @click="getMessages()">
                                    <span v-if="!loading">Refresh</span>
                                    <Spinner class="mx-auto" v-if="loading" />
                                </button>
                                <router-link :to="{name: 'orders.messages.create'}">
                                    <button class="btn btn-primary font-semibold rounded-lg px-12 w-full md:w-auto">
                                        + Add Message
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </header>
                    <div class="px-6 py-5">
                        <table class="table-fixed w-full">
                            <thead class="hidden md:table-header-group text-sm">
                                <tr>
                                    <th class="w-18 text-dark-gray font-normal py-3 text-left">QUEUE #</th>
                                    <th class="w-4/12 text-dark-gray font-normal py-3 text-left">MESSAGE NAME</th>
                                    <th class="w-2/12 text-dark-gray font-normal py-3">OPENS</th>
                                    <th class="w-2/12 text-dark-gray font-normal py-3">CLICKS</th>
                                    <th class="w-2/12 text-dark-gray font-normal py-3">SENDS</th>
                                    <th class="w-18"></th>
                                </tr>
                            </thead>
                            <tbody v-if="messages.length > 0">
                                <tr v-for="(message, index) in messages" :key="message.id">
                                    <td class="py-4 w-12 align-top">
                                        <div class="w-8 h-8 rounded-full border border-gray-500 flex items-center">
                                            <span class="mx-auto">{{ index + 1 }}</span>
                                        </div>
                                    </td>
                                    <td class="py-4">
                                        <div class="font-medium">{{ message.name }}</div>
                                        <div class="mt-2">{{ message.description }}</div>
                                        <div class="md:hidden mt-8 text-center">
                                            <div class="flex items-center">
                                                <div class="w-32">
                                                    <div class="text-dark-gray mb-2">OPENS</div>
                                                    <div>{{ getOpenPercent(message) }}</div>
                                                </div>
                                                <div class="w-32">
                                                    <div class="text-dark-gray mb-2">CLICKS</div>
                                                    <div>{{ getClickPercent(message) }}</div>
                                                </div>
                                                <div class="w-32">
                                                    <div class="text-dark-gray mb-2">SENDS</div>
                                                    <div>{{ message.sends_count }}</div>
                                                </div>
                                            </div>
                                            <div class="mt-3">
                                                <router-link :to="`/orders/${$route.params.uuid}/messages/${message.id}/edit`" class="w-full">
                                                    <button class="btn btn-secondary font-semibold rounded-lg w-full px-2 truncate">
                                                        Edit
                                                    </button>
                                                </router-link>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="hidden md:table-cell py-4 text-center">
                                        <div>{{ getOpenPercent(message) }}</div>
                                    </td>
                                    <td class="hidden md:table-cell py-4 text-center">
                                        <div>{{ getClickPercent(message) }}</div>
                                    </td>
                                    <td class="hidden md:table-cell py-4 text-center">
                                        <div>{{ message.sends_count }}</div>
                                    </td>
                                    <td class="hidden md:table-cell py-4">
                                        <router-link :to="`/orders/${$route.params.uuid}/messages/${message.id}/edit`" class="w-32">
                                            <button class="btn btn-secondary font-semibold rounded-lg w-full px-2 truncate">
                                                Edit
                                            </button>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else-if="!loading">
                                <tr>
                                    <td colspan="6" class="bg-gray-100 py-10 text-center text-gray-600">
                                        No Messages
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </DefaultBackground>
</template>

<script>
import DefaultBackground from "@/components/common/layout/DefaultBackground"
import Api from "@/api/api_v1.0"
import Spinner from "@/components/common/Spinner"

export default {
    components: {
        Spinner,
        DefaultBackground
    },
    data() {
        return {
            loading: false,
            messages: []
        }
    },
    async mounted() {
        await this.getMessages()
    },
    methods: {
        async getMessages() {
            this.loading = true
            const response = await Api.getMessagesOfOrder(this.$route.params.uuid)
            this.messages = response.data.data
            this.loading = false
        },
        getOpenPercent(message) {
            const sends = parseInt(message.sends_count)
            const opens = parseInt(message.opens_count)
            if (sends === 0) {
                return '0.0%'
            } else {
                const percent = (opens / sends) * 100
                return `${percent.toFixed(1)}%`
            }
        },
        getClickPercent(message) {
            const sends = parseInt(message.sends_count)
            const clicks = parseInt(message.clicks_count)
            if (sends === 0) {
                return '0.0%'
            } else {
                const percent = (clicks / sends) * 100
                return `${percent.toFixed(1)}%`
            }
        }
    }
}
</script>
